<template>
  <div class="editbox" v-show="!!item">
    <infoSlider :style="{zIndex: 999}" :show="!!item" @close="$emit('close')"  :label="'合作代理資訊'" defaultClass="123" :width="481" :icon="'partner'">
      <div class="editCube">
        <RT :options="['詳細資料', '合作紀錄']" :defaultValue="page" @input="page=$event"/>
        <template v-if="page==='詳細資料'">
        <section v-if="item">
          <template v-if="edit!=='info'">
          <EditBtn @click="edit='info'" class="absbtn" :style="{backgroundColor: 'var(--color-pri)'}"/>
          <!-- <div class="field">
            <div>編號</div>
            <div :style="{fontWeight: '900', fontSize: '24px', color: 'var(--color-pri)'}">{{item.status}}</div>
          </div> -->
          <div class="field">
            <div>類別</div>
            <div>{{item.tag}}</div>
          </div>
          <div class="field">
            <div>名稱</div>
            <div>{{item.name||'-'}}</div>
          </div>
          <div class="field">
            <div>電話</div>
            <div>{{item.tel?.join(' / ')||'-'}}</div>
          </div>
          <div class="field">
            <div>統編</div>
            <div>{{item.taxID||'-'}}</div>
          </div>
          <div class="field">
            <div>縣市</div>
            <div>{{item.country||'-'}}</div>
          </div>
          <div class="field">
            <div>地址</div>
            <div>{{item.address||'-'}}</div>
          </div>
          <div class="field">
            <div>窗口</div>
            <div>{{item.head||'-'}}</div>
          </div>
          <div class="field">
            <div>電話</div>
            <div>{{item.headTel||'-'}}</div>
          </div>
          <hr>
          <div class="field-foot">
            <div :style="{textAlign:'start'}">創建日期</div>
            <div :style="{marginLeft: 'auto'}">{{moment(item.createTime).format('yyyy/MM/DD HH:mm')}}</div>
          </div>
          <div class="field-foot">
            <div :style="{textAlign:'start'}">更新日期</div>
            <div :style="{marginLeft: 'auto'}">{{moment(item.updateTime).format('yyyy/MM/DD HH:mm')}}</div>
          </div>
          </template>
          <template v-else-if="edit==='info'&&editItem">
            <div class="required-hint">* 為必填欄位</div>
            <div class="field field-edit">
              <div>類別</div>
                <Select1 :defaultValue="editItem.tag" @input="editItem.tag=$event" :width="'160px'">
                <option :value="null">類別</option>
                <option v-for="({name}, i) in partnerCategories" :key="`country-${i}`" :value="name">{{name}}</option>
              </Select1>
            </div>
            <div class="field field-edit">
              <div>名稱 <span class="required">*</span></div>
              <div class="input-wrap">
                <input type="text" :style="{width: '275px', borderColor: errors.name ? '#FF7373' : ''}" v-model="editItem.name" @input="errors.name=false">
                <span class="error-msg" v-if="errors.name">請填寫名稱</span>
              </div>
            </div>
            <div class="field field-edit">
              <div>電話 <span class="required">*</span></div>
              <div class="input-wrap">
                <input type="tel" :style="{width: '200px', borderColor: errors.tel ? '#FF7373' : ''}" v-model="editItem.tel" @input="errors.tel=false">
                <span class="error-msg" v-if="errors.tel">請填寫電話</span>
              </div>
            </div>
            <div class="field field-edit">
              <div>統編 <span class="required">*</span></div>
              <div class="input-wrap">
                <input type="text" :style="{width: '145px', borderColor: errors.taxID ? '#FF7373' : ''}" v-model="editItem.taxID" @input="errors.taxID=false">
                <span class="error-msg" v-if="errors.taxID">請填寫統編</span>
              </div>
            </div>
            <div class="field field-edit">
              <div>縣市</div>
              <Select1 :width="'185px'" :defaultValue="editItem.country" @input="editItem.country=$event">
                <option :value="null">縣市</option>
                <option v-for="(country, i) in countries" :key="`country-${i}`" :value="country">{{country}}</option>
              </Select1>
            </div>
            <div class="field">
              <div>地址</div>
              <textarea v-model="editItem.address" :style="{minHeight: '120px', width: '275px'}"></textarea>
            </div>
            <div class="field field-edit">
              <div>窗口</div>
              <input type="text"  :style="{width: '275px'}" v-model="editItem.head">
            </div>
            <div class="field field-edit">
              <div>電話</div>
              <input type="tel"  :style="{width: '200px'}" v-model="editItem.headTel">
            </div>
            <BtnsS :style="{marginTop: '15px'}" @cancel="edit=null" @save="save"/>
          </template>
          <template>
          </template>
        </section>
        <section>
          <template v-if="edit==='color'">
          <ColorPicker type="linear" v-model="edit" class="ColorPicker" :style="{zIndex: 1000, marginInline: 'auto'}"
          @changeColor="changeColor" :titleConfig="titleConfig"
          @onClose="onClosePicker"
          :pDeg="90"
          :pColor="pColor"
          :showClose="true"
          :closeOnClickBody="false"/>
          <BtnsS @cancel="edit=null" @save="save"/>
          </template>
          <button v-else class="colorBox" @click="edit='color'" :style="{backgroundColor: item?.color || '#CACACA'}"></button>
        </section>
        <section class="top" label="註記" v-if="item">
          <template v-if="edit!=='remark'">
          <div v-html="(item.remark||'').replaceAll('\n', '<br>')"></div>
          <EditBtnCo @click="edit='remark'" class="absbtn editbtn1" :style="{top: '7px', right: '13px'}"/>
          </template>
          <template v-else-if="edit==='remark'">
            <textarea v-model="editItem.remark"></textarea>
            <BtnsS @cancel="edit=null" @save="save"/>
          </template>
        </section>
        <section class="top" label="已綁定" v-if="item">
          <div class="flexcol" :style="{gap: '20px'}">
            <div v-for="(lked, l) in item.linked" :key="l">
              <div>{{lked.name}}</div>
              <div>{{rolesmap[lked.role]}}</div>
            </div>
          </div>
        </section>
        </template>
        <template v-else>
          <div v-for="(project, p) in projects" :key="`project-${p}`" class="projectCube" @click="$router.push({ name: 'restProjectSingle', params: {id: project._id}, query: { page: '預訂統計' } })">
            <div class="name">{{project.projectName}}</div>
            <div>專案ID: {{project.projectId}}</div>
            <div>商店: {{project.store}}</div>
            <div class="col">
              <div>可預約/訂購日期</div>
              <div class="dates" v-if="!project.useRange">
                <span v-for="(date, d) in project.projectDates" :key="`date-${d}`">{{date}}</span>
              </div>
              <div v-else>{{toDate(project.projectRange.start)}} ~ {{toDate(project.projectRange.end)}}</div>
            </div>
            <div  class="col">
              <div>專案有效日期</div>
              <div>{{toDate(project.bookableRange.start)}} ~ {{toDate(project.bookableRange.end)}}</div>
            </div>
          </div>
          <button class="pullMore" v-if="projectsCount>projects.length" @click="projectPage=projectPage+1">載入更多</button>
        </template>
      </div>
    </infoSlider>
  </div>
</template>

<script>
import EditBtn from '../../components/btn/edit.vue'
import EditBtnCo from '../../components/btn/editConvert.vue'
import infoSlider from '../../components/infoSlider_v2.vue'
import { getapi, postapi } from '../../store/fetch'
import { mapState } from 'vuex'
import ColorPicker from 'vue2-color-picker-gradient'
const VUE_APP_COMPANY = JSON.parse(process.env.VUE_APP_COMPANY)
export default {
  props: ['item', 'countries', 'rolesmap', 'partnerCategories'],
  components: {
    infoSlider,
    EditBtn,
    EditBtnCo,
    ColorPicker
  },
  data () {
    return {
      page: '詳細資料',
      datarange: '近半年',
      VUE_APP_COMPANY,
      category: null,
      products: [],
      count: 0,
      invoices: [],
      categories: [],
      edit: null,
      errors: {},
      editItem: null,
      projects: [],
      projectsCount: 0,
      projectPage: 0,
      pColor: {
        hex: '#194d33',
        hex8: '#194d33',
        hsl: { h: 150, s: 0.5, l: 0.2, a: 1 },
        hsv: { h: 150, s: 0.66, v: 0.3, a: 1 },
        rgba: { r: 25, g: 77, b: 51, a: 1 },
        a: 1,
        color: 'rgba(0,0,0,1)'
      },
      titleConfig: {
        show: false,
        text: '請選擇顏色'
      },
      pDeg: 60
    }
  },
  watch: {
    async projectPage () {
      await this.getProjects()
    },
    item: {
      async handler () {
        this.projectPage = 0
        await this.getProjects()
        this.edit = null
      },
      deep: true
    },
    edit () {
      this.errors = {}
      switch (this.edit) {
        case 'remark':
          this.editItem = { remark: this.item.remark }
          break
        case 'info':
          this.editItem = {
            name: this.item.name,
            address: this.item.address,
            tel: this.item.tel,
            status: this.item.status,
            taxID: this.item.taxID,
            country: this.item.country,
            head: this.item.head,
            headTel: this.item.headTel,
            tag: this.item.tag,
            contract: this.item.contract
          }
          break
        case 'color':
          this.editItem = { color: this.item.color || '#CACACA' }
          break
        default:
          this.editItem = null
          break
      }
    }
  },
  async mounted () {
  },
  computed: {
    ...mapState({
      restaurants: 'restaurants'
    })
  },
  methods: {
    async getProjects () {
      const projects = await getapi(`projects/partner/${this.item._id}?page=${this.projectPage}`)
      if (this.projectPage > 0) {
        this.projects = [...this.projects, ...projects.data]
      } else {
        this.projects = projects.data
      }
      this.projectsCount = projects.count
    },
    changeColor ({ color }) {
      this.editItem.color = color.hex
    },
    onClosePicker () {},
    async save () {
      this.errors = {}
      if (this.edit === 'info') {
        if (!this.editItem.name) this.errors.name = true
        if (!this.editItem.tel) this.errors.tel = true
        if (!this.editItem.taxID) this.errors.taxID = true
        if (Object.keys(this.errors).length) return
      }
      let params = {}
      switch (this.edit) {
        case 'info':
          params = { ...this.editItem }
          params.agencyID = (params.agency && params.agency.taxID) || this.agencyText
          break
        default:
          params[this.edit] = this.editItem[this.edit]
          break
      }
      const ret = await postapi(`partners/${this.item._id}`, params)
      if (ret) {
        this.$emit('updateItem', ret)
        this.edit = null
      }
    }
  }
}
</script>
<style lang="scss">
.editbtn1 {
  &.absbtn {
    width: 32px;
    height: 32px;
    &::before {
      background-color: var(--color-pri);
    }
  }
}
</style>
<style lang="scss" scoped>
*, *::before, *::after {
  box-sizing: border-box;
}
.pullMore {
  height: 60px;
  font-size: 20px;
  background-color: var(--color-checked);
  color: #FFFFFF;
  border-radius: 3px;
}
.projectCube {
  text-align: start;
  border: 1px solid #CACACA;
  padding: 20px;
  font-size: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  color: #5E5E5E;
  .name {
    color: var(--color-pri);
    font-size: 28px;
    font-weight: 700;
  }
  .col {
    display: flex;
    flex-direction: column;
    &>:nth-child(1) {
      font-size: 16px;
    }
    &>:nth-child(2) {
      padding-left: 1em;
      font-size: 22px;
    }
  }
  .dates {
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
    span {
      border: 1px solid var(--color-checked);
      padding: 3px 6px;
      border-radius: 3px;
    }
  }
}
.ColorPicker {
  right: 500px;
}
.colorBox {
  width: 100%;
  height: 60px;
}
.invoiceList {
  margin: 7px;
  max-height: calc(100vh - 450px);
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 9px;
    background-color: #F5F5F5;
  }
  &::-webkit-scrollbar-button {
    display: none;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 20px;
    box-shadow: inset 0 0 6px #0000004d;
    background-color: var(--color-pri);
  }
  &::-webkit-scrollbar-track {
    border: none;
    border-radius: 20px;
    background-color: #d8d8d8;
    border: 2px solid #FFFFFF!important;
  }
  &>div {
    padding-inline: 14px 16px;
    display: grid;
    grid-template-columns: 100px 110px 1fr;
    gap: 29px;
    font-size: 16px;
    letter-spacing: .1em;
    height: 49px;
    min-height: 49px;
    align-items: center;
    &>div:nth-child(1),
    &>div:nth-child(2) {
      text-align: start;
    }
    &>div:nth-child(3) {
      text-align: end;
    }
  }
}
.box1 {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.count {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  background-color: #ffe3e3;
  height: 70px;
  border-radius: 3px;
  letter-spacing: .1em;
  padding: 10px 31px 10px 14px;
}
.consume {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  background-color: #ffe3e3;
  height: 70px;
  border-radius: 3px;
  letter-spacing: .1em;
  padding: 10px 31px 10px 14px;
  color: var(--color-pri);
  background-color: var(--color-bar);
}
#storequotation {
  display: flex;
  flex-direction: column;
  &>:nth-child(1) {
    padding: 10px 20px;
    min-height: 60px;
    background-color: var(--color-bar);
    font-size: 18px;
  }
}
#quotation-priceList {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 0 40px;
  &>div{
    width: 350px;
    padding-block: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-family: 'Noto Sans TC';
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 150%;
    letter-spacing: 0.05em;
    &>:nth-child(1) {
      text-align: start;
    }
    &>:nth-child(2) {
      width: 100px;
      font-weight: 700;
      text-align: center;
    }
    input[type=text] {
      width: 100px;
      height: 49px;
      color: #787878;
      border: 1px solid #C4C4C4;
      border-radius: 3px;
      font-weight: 700;
      text-align: center;
      font-size: 20px;
      line-height: 150%;
    }
  }
}

.linethrough {
  text-decoration-line: line-through;
  font-weight: 400;
  font-style: italic;
}
.cate {
  width: 160px;
  height: 80px;
  min-height: 80px;
  border: 1.5px solid var(--color-pri);
  color: var(--color-pri);
  background-color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  font-family: 'Noto Sans TC';
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 150%;
  letter-spacing: 0.05em;
  &.selected {
    background-color: var(--color-pri);
    color: #FFFFFF;
  }
}
#quotation {
  display: grid;
  grid-template-columns: 200px 1fr;
  grid-template-rows: 1fr;
  &>div{
    height: 100%;
    max-height: 100%;
    overflow-y: auto;
  }
  &>:nth-child(2) {
    padding: 22px 63px 22px 47px;
  }
  &>:nth-child(1) {
    background-color: var(--color-bar);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding: 20px;
    gap: 15px;
  }
}
.flexcol {
  display: flex;
  flex-direction: column;
  &>div{
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    &>div:nth-child(1){
      font-style: normal;
      font-weight: 400;
      font-size: 20px;
      line-height: 23px;
      letter-spacing: 0.1em;
      color: #5E5E5E;
    }
    &>div:nth-child(2){
      font-weight: 400;
      font-size: 16px;
      line-height: 19px;
      text-align: right;
      letter-spacing: 0.1em;
      color: #5E5E5E;
    }
  }
}
.viewsheet {
  margin: 10px 25px 14px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--color-bar);
  color: var(--color-pri);
  font-weight: 400;
  font-size: 20px;
  line-height: 29px;
  letter-spacing: 0.1em;
}
.highlight {
  color: #FF7373;
  font-weight: 700;
}
.orderTypes {
  display: flex;
  align-items: center;
}
.orderTypes > input {
  appearance: none;width: 54px;
  height: 39px;
  background: #FFFFFF;
  border: 1.5px solid var(--c);
  border-radius: 20px;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  letter-spacing: 0.1em;
  display: flex;
  align-items: center;
  justify-content: center;
  &::before {
    content: attr(value);
  }
  &.自取 {
    border: 1.5px solid var(--自取);
    color:  var(--自取);
    &:checked {
      background-color: var(--自取);
    }
  }
  &.宅配 {
    border: 1.5px solid var(--宅配);
    color:  var(--宅配);
    &:checked {
      background-color: var(--宅配);
    }
  }
  &:checked {
    color: #FFFFFF;
  }
}

div.vip, div.vvip, div.supervip {
  width: 30px;
  height: 30px;
  background-repeat: no-repeat;
  background-position: bottom;
  background-size: contain;
  appearance: none;
}

div.vip {
  background-image: url(/vip.svg);
  mask-image: none;
}
div.supervip {
  background-image: url(/supervip.svg);
  mask-image: none;
}
div.vvip {
  background-image: url(/vvip.svg);
  mask-image: none;
}
input.vip, input.vvip, input.supervip, .none {
  width: 30px;
  height: 30px;
  background-repeat: no-repeat;
  background-position: bottom;
  background-size: contain;
  appearance: none;
  mask-repeat: no-repeat;
  mask-position: center;
  mask-size: contain;
  background-color: #CACACA;
  &:checked {
    mask-image: none;
    background-color: transparent;
  }
}
input.vip {
  mask-image: url(/vip.svg);
}
input.vip:checked {
  background-image: url(/vip.svg);
}
input.vvip {
  mask-image: url(/vvip.svg);
}
input.vvip:checked {
  background-image: url(/vvip.svg);
}
.none {
  mask-image: url(/svg/btn/close.svg);
  mask-size: 20px;
}
input.supervip {
  mask-image: url(/supervip.svg);
}
input.supervip:checked {
  background-image: url(/supervip.svg);
}
.hr2 {
  margin: .5em 0;
  border-block: 3px solid #FFFFFF;
  border-inline: 8px solid var(--color-pri);
  background-color: var(--color-pri);
  height: 8px;
}
.required {
  color: #FF7373;
}
.required-hint {
  font-size: 13px;
  color: #FF7373;
  text-align: end;
}
.input-wrap {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.error-msg {
  font-size: 12px;
  color: #FF7373;
  line-height: 1.4;
}
.editbox {
  position: fixed;
  left: auto;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 10;
}
label {
  position: relative;
  z-index: 1;
}
.ul {
  position: absolute;
  right: 0;
  width: 350px;
  background-color: #FFFFFF;
  max-height: 230px;
  overflow-y: auto;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
  z-index: 99;
  .li {
    padding-block: 7.25px;
    padding-inline: .75em;
    min-height: 55px;
    display: flex;
    align-items: flex-start;
    gap: 10px;
    line-height: 40px;
    &:hover {
      background-color: #CACACA;
    }
  }
}
.removebtn {
  margin-left: auto;
  height: 40px;
}
.absbtn {
  position: absolute;
  top: 20px;
  right: 18px;
}
.agency-box {
  display: flex;
  align-items: center;
  height: 40px;
  padding-inline: .75em;
  border: 1px solid #CACACA;
  border-radius: 3px;
  font-size: 18px;
  button {
    background-color: #CACACA;
    width: 23px;
    mask-image: url(/svg/btn/close.svg);
    mask-size: 15px;
    mask-repeat: no-repeat;
    mask-position: center;
    border: none;
    outline: 1px solid #CACACA;
    box-sizing: content-box;
    padding: 0;
  }
}
.internalremark {
  display: flex;
  flex-direction: column;
  gap: 6px;
  &>:nth-child(1) {
    font-weight: 400;
    font-size: 16px;
    line-height: 180%;
    color: #FFFFFF;
    width: 125px;
    height: 30px;
    background: #FF7373;
    border-radius: 50px;
  }
  &>:nth-child(2) {
    text-align: start;
    font-weight: 400;
    font-size: 15px;
    line-height: 180%;
    color: #FF7373;
  }
}
.field-foot {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  font-weight: 400;
  font-size: 16px;
  line-height: 23px;
  color: #999999;
  letter-spacing: 0;
  &>div:nth-child(1) {
    text-align: start;
  }
  &>div:nth-child(2) {
    text-align: end;
  }
}
hr {
  height: 1px;
  border: none;
  background-color:#CACACA;
  width: 100%;
  margin: 0;
}
.flexrow {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.field {
  display: grid;
  grid-template-columns: 70px 1fr;
  gap: 28px;
  &.field-edit {
    line-height: 35px;
    position: relative;
  }
  &>:nth-child(1) {
    text-align: end;
  }
  &>:nth-child(2) {
    text-align: start;
  }
  input[type=tel], input[type=text], textarea {
    width: -webkit-fill-available;
    height: 40px;
    border: 1px solid #CACACA;
    border-radius: 3px;
    padding-inline: .75em;
    box-sizing: border-box;
    font-size: 18px;
    color: #5E5E5E;
  }
  textarea {
    padding-block: .5em;
  }
}
section {
  position: relative;
  border: 1px solid #B9B9B9;
  border-radius: 10px;
  padding: 20px 20px 13px 23px;
  width: 100%;
  font-weight: 400;
  font-size: 20px;
  line-height: 29px;
  letter-spacing: 0.1em;
  color: #5E5E5E;
  display: flex;
  flex-direction: column;
  gap: 11px;
  height: fit-content;
}
section.top {
  padding: 0;
  &::before {
    content: attr(label);
    display: inline;
    width: 100%;
    height: 45px;
    background-color: var(--color-pri);
    color: #FFFFFF;
    text-align: start;
    border-radius: 10px 10px 0 0;
    display: flex;
    align-items: center;
    padding-inline: 28px;
  }
  &>div, &>textarea{
    border: none;
    padding: 10px 25px 14px 28px;
    height: fit-content;
    text-align: start;
    font-weight: 400;
    font-size: 20px;
    line-height: 29px;
    letter-spacing: 0.1em;
    color: #787878;
  }
  textarea {
    min-height: 200px;
  }
}
section.orders>div:nth-child(1) {
  gap: 15px;
  display: flex;
  flex-direction: column;
}
.editCube {
  flex: 1;
  padding: 31px 20px 30px 30px;
  display: grid;
  grid-template-columns: 1fr;
  width: 100%;
  margin-right: 8px;
  height: 100%;
  overflow-y: auto;
  align-content: flex-start;
  gap: 19px;
}
</style>
